import { inject } from '@angular/core';
import {
  AuthApiActions,
  AuthDeviceActions,
  AuthLoginActions,
} from '@kinet-open-network/client/auth/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { CustomerContextService } from './customer-context.service';

export const setCustomerOnInit$ = createEffect(
  (actions = inject(Actions), ctxService = inject(CustomerContextService)) => {
    return actions.pipe(
      ofType(AuthDeviceActions.initialized),
      tap(() => ctxService.initContext()),
    );
  },
  { dispatch: false, functional: true },
);

export const clearCustomerOnLogout$ = createEffect(
  (actions = inject(Actions), ctxService = inject(CustomerContextService)) => {
    return actions.pipe(
      ofType(AuthApiActions.logoutSuccess, AuthDeviceActions.expired),
      tap(() => ctxService.clearContext(true)),
    );
  },
  { dispatch: false, functional: true },
);

export const clearContextBeforeLogin$ = createEffect(
  (actions = inject(Actions), ctxService = inject(CustomerContextService)) => {
    return actions.pipe(
      ofType(AuthLoginActions.login),
      tap(() => ctxService.clearContext(true)),
    );
  },
  { dispatch: false, functional: true },
);

export const setCustomerLogin$ = createEffect(
  (actions = inject(Actions), ctxService = inject(CustomerContextService)) => {
    return actions.pipe(
      ofType(AuthApiActions.loginSuccess),
      tap(() => ctxService.initContext()),
    );
  },
  { dispatch: false, functional: true },
);

export const setCustomerRefresh$ = createEffect(
  (actions = inject(Actions), ctxService = inject(CustomerContextService)) => {
    return actions.pipe(
      ofType(AuthApiActions.updateProfileSuccess, AuthDeviceActions.refreshed),
      tap(() => ctxService.refreshContext()),
    );
  },
  { dispatch: false, functional: true },
);
